var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',_vm._l((_vm.station.modules),function(module){return _c('li',{key:module.id,staticClass:"reading-item"},[_c('header',[_vm._v(_vm._s(_vm.getModuleName(module)))]),_c('LatestStationReadings',{attrs:{"id":_vm.station.id,"moduleKey":_vm.getModuleKey(module)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }